import { useVodPageStore } from "@/stores/VodPage";
import { type RouteLocationNormalized } from 'vue-router';

const {
	setShowAllVod
} = useVodPageStore();

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) {
		setShowAllVod(to.query.type as string);
	}
});